import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PAGE_URLS } from 'utils/constants/index.js';
import { getUserRoles } from 'reducers/users';
import { ROLES } from 'utils/constants/roles';
import { getSecurityCompanyBillingInfo } from 'reducers/securityCompany/index';

const RedirectedRoute = ({
  component: Component,
  authenticated,
  roles,
  billingInfo,
  exact,
}) => {
  return (
    <Route
      exact={exact}
      render={props =>
        authenticated ? (
          <Redirect
            to={{
              pathname:
                roles.includes(ROLES.SECURITY_COMPANY_MANAGER.id) &&
                !billingInfo?.paymentMethod?.last4
                  ? PAGE_URLS.ACCOUNT.link
                  : PAGE_URLS.DASHBOARD.link,
              state: { from: props.location },
            }}
          />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

RedirectedRoute.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  exact: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  billingInfo: PropTypes.object.isRequired,
  location: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  roles: PropTypes.array,
};

const mapStateToProps = state => ({
  authenticated: state.auth.authenticated,
  roles: getUserRoles(state),
  billingInfo: getSecurityCompanyBillingInfo(state),
});

export default connect(mapStateToProps)(RedirectedRoute);
